import { useMutation } from '@apollo/client';
import { useSetRecoilState } from 'recoil';

import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';
import UpdateContractUpliftSettingsMutation from '@/graphql/contracts/updateContractUpliftSettings.mutation.gql';
import { notificationService } from '@/services/notification/notification.client';
import { UpdateContractUpliftSettings, UpdateContractUpliftSettingsVariables } from
  '@/graphql/contracts/_generated_/updateContractUpliftSettings.mutation';
import { fieldVerificationRefreshTrigger } from '../../ContractIq/ContractIq.state';

export type UpdateContractUplift = Omit<UpdateContractUpliftSettingsVariables['input'], 'contractId'>;

export default function useUpdateContractUpliftSettings(contractId: string) {
  const setRefreshTrigger = useSetRecoilState(fieldVerificationRefreshTrigger);

  const [update, { loading }] = useMutation<UpdateContractUpliftSettings, UpdateContractUpliftSettingsVariables>(
    UpdateContractUpliftSettingsMutation,
    {
      client: apolloClientContracts,
      onCompleted: () => {
        notificationService.open({
          title: 'Update Contract Uplifts Headers',
          text: 'Contract uplifts headers successfully updated',
          type: 'success'
        });
        setRefreshTrigger((prev) => prev + 1);
      },
    },
  );

  const updateContractUpliftSettings = async (upliftData: UpdateContractUplift,
    cbOnError?: () => void) => {


    update({
      variables: {
        input: { ...upliftData, contractId }
      },
      onError: (err) => {
        notificationService.open({
          title: 'Error',
          text: err.message,
          type: 'danger'
        });

        cbOnError?.();
      }
    });

  };

  return {
    updateContractUpliftSettings,
    isLoadingUpdateContractUplift: loading
  } as const;
}
